(function () {
  // Mobile menu
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ah-burger]');
    if (!b) return;
    var d = document.getElementById(b.getAttribute('aria-controls'));
    if (!d) return;
    var open = d.hasAttribute('open');
    if (open) { d.removeAttribute('open'); } else { d.setAttribute('open', ''); }
    b.setAttribute('aria-expanded', String(!open));
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ah-thumb]');
    if (!t) return;
    var g = t.closest('[data-ah-gallery]');
    var main = g && g.querySelector('[data-ah-main]');
    if (!main) return;
    main.src = t.getAttribute('data-src');
    main.srcset = '';
    main.alt = t.getAttribute('data-alt') || '';
    main.classList.toggle('is-cover', t.getAttribute('data-cover') === 'true');
    g.querySelectorAll('[data-ah-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
  });

  // Pack selector + add to cart
  function initBuy(root) {
    var packs = root.querySelectorAll('.ah-pack');
    function sync() {
      packs.forEach(function (p) {
        var r = p.querySelector('input[type=radio]');
        p.classList.toggle('is-active', r.checked);
      });
    }
    packs.forEach(function (p) {
      p.querySelector('input[type=radio]').addEventListener('change', sync);
    });
    root.querySelectorAll('[data-ah-slot]').forEach(function (s) {
      s.addEventListener('change', function () {
        var icon = s.closest('.ah-slot').querySelector('[data-ah-slot-icon]');
        var tpl = root.querySelector('template[data-ah-icon="' + s.selectedOptions[0].getAttribute('data-kind') + '"]');
        if (icon && tpl) icon.innerHTML = tpl.innerHTML;
      });
    });
    sync();

    var btn = root.querySelector('[data-ah-atc]');
    var msg = root.querySelector('[data-ah-msg]');
    btn.addEventListener('click', function () {
      var chosen = root.querySelector('input[name=ah-pack]:checked');
      var counts = {};
      if (chosen.value === 'single') {
        counts[root.getAttribute('data-current-variant')] = 1;
      } else {
        root.querySelectorAll('[data-ah-slot]').forEach(function (s) {
          counts[s.value] = (counts[s.value] || 0) + 1;
        });
      }
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      btn.setAttribute('disabled', '');
      msg.textContent = '';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Something went wrong.');
        if (window.AHCart) { btn.removeAttribute('disabled'); window.AHCart.open(); } else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
      }).catch(function (err) {
        msg.textContent = err.message;
        btn.removeAttribute('disabled');
      });
    });
  }
  document.querySelectorAll('[data-ah-buy]').forEach(initBuy);
})();
